//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            index: 0
        };
    },

    computed: {
        planets () {
            return this.$store.getters.planets.map(planet => ({
                name: planet.name[this.$lang.locale],
                percentage: this.getPercentage(planet),
                learned: this.$store.getters.achievements
                    .filter(achievement => achievement.week === planet.week && this.$store.getters.hasUserFinishedDay(achievement.week, achievement.day))
                    .reduce((acc, achievement) => acc.concat(achievement.learned[this.$lang.locale]), [])
            }));
        },
        activePlanet () {
            return this.planets[this.index];
        }
    },

    methods: {
        getPercentage (planet) {
            if (this.$store.getters.hasUserFinishedDay(planet.week, 5)) {
                return 100;
            } else if (this.$store.getters.hasUserFinishedDay(planet.week, 4)) {
                return 80;
            } else if (this.$store.getters.hasUserFinishedDay(planet.week, 3)) {
                return 60;
            } else if (this.$store.getters.hasUserFinishedDay(planet.week, 2)) {
                return 40;
            } else if (this.$store.getters.hasUserFinishedDay(planet.week, 1)) {
                return 20;
            }

            return 0;
        }
    }
};
